import React from "react"
import { Col, Form, Input } from "reactstrap"
import Select2 from "react-select2-wrapper"
import ReactInputMask from "react-input-mask"
import { isEmpty } from "lodash"

function PastDueAppointmentForm(props) {
  return (
    <Form className="needs-validation" noValidate autoComplete="off">
      <div className="form-row">
        <Col className="mb-3" lg="6">
          <label className="form-control-label">Cliente</label>
          <Select2
            className="form-control"
            value={props.appointmentBody.customer?._id || props.appointmentBody.customer}
            onChange={(e) => props.selectCustomer(e.target.value)}
            data={props.customers.map(c => ({ id: c._id, text: c.shortName }))}
            options={{ placeholder: "Selecione o Cliente" }}
          />
        </Col>

        <Col className="mb-3" lg="6">
          <label className="form-control-label">Projeto</label>
          <Select2
            className="form-control"
            disabled={isEmpty(props.appointmentBody.customer)}
            value={props.appointmentBody.project?._id || props.appointmentBody.project}
            onChange={(e) => props.selectProject(e.target.value)}
            data={props.projects.map(p => ({ id: p._id, text: p.name }))}
            options={{ placeholder: "Selecione o Projeto" }}
          />
        </Col>
      </div>

      <div className="form-row">
        <Col className="mb-3" lg="6">
          <label className="form-control-label">Data</label>
          <Input 
            type="date" 
            value={props.appointmentBody.date}
            onChange={e => props.setAppointmentBody({ ...props.appointmentBody, date: e.target.value })} 
          />
        </Col>

        <Col className="mb-3" lg="6">
          <label className="form-control-label">Horas</label>
          <Input 
            mask="999:99" 
            tag={ReactInputMask} 
            type="text" 
            value={props.appointmentBody.hours}
            onChange={e => props.setAppointmentBody({ ...props.appointmentBody, hours: e.target.value.replace(/_/, "0") })} 
          />
        </Col>
      </div>

      <div className="form-row">
        <Col md="12">
          <label className="form-control-label">Observação</label>
          <Input 
            type="textarea" 
            rows="3" 
            value={props.appointmentBody.description}
            onChange={e => props.setAppointmentBody({ ...props.appointmentBody, description: e.target.value })} 
          />
        </Col>
      </div>
    </Form>
  )
}

export default PastDueAppointmentForm